import React from "react";
import "./About_us_banner.css";

function About_us_banner() {
  return (
    <>
      <section className="About_us_banner">
        <div className="img_holder">
          <img
            className="banner_img"
            src="/assets/images/about_us/about_us_banner/banner_img.png"
            alt="banner img"
          />
        </div>
      </section>
    </>
  );
}

export default About_us_banner;
